import { Component, Input } from "@angular/core";

import type { WizardComponent } from "./wizard.component";

@Component({
  selector: "app-wizard-completion-step",
  templateUrl: "./wizard-completion-step.component.html",
  host: { style: "display: contents" },
  standalone: false
})
export class WizardCompletionStepComponent {
  @Input({ required: true }) view!: WizardComponent;
}
